import type { ModuleMenuItemResponse } from '@protoss/shared';
import { useWorkspace } from '../../../contexts/WorkspaceContext';

interface UseModuleMenuResult {
  items: ModuleMenuItemResponse[];
  isLoading: boolean;
  error: string | null;
}

/**
 * useModuleMenu - returns the DB-driven module nav items for the active module.
 *
 * Data is fetched once in WorkspaceContext and cached for the lifetime of the
 * session, preventing a re-fetch on every page navigation.
 */
export function useModuleMenu(): UseModuleMenuResult {
  const { moduleMenuItems, isLoadingModuleMenu } = useWorkspace();
  return { items: moduleMenuItems, isLoading: isLoadingModuleMenu, error: null };
}
